module.exports = __webpack_public_path__ + "img/laptopGuy.f7b81e61.svg";